import styled from "styled-components"

export const PreviewWrapper = styled.div`
  background: #ffffff;
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const HeaderSection = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 8px 24px;
  margin-top: 0;
`

export const HeadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`

export const HeadingTitle = styled.h1`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
`

export const HeadingDescription = styled.p`
  font-size: 14px;
  color: #576066;
`

export const ContentBody = styled.div`
  display: flex;
  flex-direction: column;
`

export const ScanBottomSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  justify-content: center;
`

export const ImageCardContainer = styled.div<{ $height: number }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px;
  background: #ffffff;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  width: 100%;
  height: ${(props) => props.$height}px;
`

export const ImagePreviewWrapper = styled.div<{ $height: number }>`
  position: relative;
  width: 100%;
  height: ${(props) => props.$height}px;
  border-radius: 24px;
  overflow: hidden;
`

export const ImagePreview = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
`

export const BottomActions = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  padding: 12px 24px 24px;
  background: #ffffff;
  margin-top: auto;
`

export const RetakeTextContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: baseline;
  font-size: 14px;

  @media screen and (max-width: 374px) {
    flex-wrap: wrap;
    justify-content: center;
  }
`

export const RetakePromptText = styled.span`
  font-weight: 400;
  line-height: 1.6;
  white-space: nowrap;
`

export const RetakeButton = styled.button`
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.6;
  color: #0da3ba;
  text-align: center;
  white-space: nowrap;

  &:active {
    opacity: 0.7;
  }
`

export const ImageMask = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`

export const NotFoundContentBox = styled.div`
  padding: 0px var(--app-horizontal-padding);
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const NotFoundErrorText = styled.div`
  color: var(--Schemes-System-color-On-Error-Container, #ff4921);
  text-align: center;
  font-weight: 600;
  line-height: 160%;
  margin-bottom: 8px;
`

export const NotFoundDescription = styled.div`
  text-align: center;
`
